import { gql } from '@apollo/client';

export const GET_MONITORING_FORM_SUBMISSION_ROWS = gql`
  query GetMonitoringFormSubmissionRows($input: GetMyFormInput!) {
    rows: getMonitoringFormSubmissionRows(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
          date
          periodNumber
          status
          statusDate
          respondent {
            id
            firstName
            lastName
          }
          submissionIds
          hasSubmission
        }
      }
    }
  }
`;
